module.exports = __webpack_public_path__ + "static/media/test.c930e248.jpg";